var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useRef, useState } from "react";
import { Container, Icon, Link, LogoBg, LogoImg, ModalContainer, NoLink, SideBar, ToggleContainer, ToggleTxt, Txt, } from "./AdminSideBar.styles";
import Logo from "../assets/Navbar/MilestoneLogo.svg";
import LogoSmall from "../assets/AdminSideBar/milestone-logo-small.svg";
import ToggleIcon from "../assets/AdminSideBar/Toggle";
import { useRouteMatch } from "react-router-dom";
import { intersect } from "../routes";
export var AdminSideBar = function (_a) {
    var _b = _a.open, open = _b === void 0 ? false : _b, links = _a.links, userPermissions = _a.userPermissions;
    var url = useRouteMatch().url;
    var _c = __read(useState(open), 2), isOpen = _c[0], setIsOpen = _c[1];
    var modal = useRef(null);
    var handleClose = function (newOpen) {
        if (newOpen !== undefined)
            setIsOpen(newOpen);
        else
            setIsOpen(function (open) { return !open; });
    };
    var toggleClick = function () {
        handleClose();
    };
    //generic click handler for the document
    var handleClick = function (event) {
        if (modal.current) {
            //check if the drop down is open and not the target
            if (event.target &&
                !modal.current.contains(event.target)) {
                //close modal
                handleClose(false);
            }
        }
    };
    React.useEffect(function () {
        document.addEventListener("click", handleClick);
        return function () { return document.removeEventListener("click", handleClick); };
    }, []);
    var mapLinks = function (links, isModal) {
        return links.map(function (link) {
            if (!link.path ||
                (link.permissions &&
                    !intersect(userPermissions, link.permissions).length)) {
                return (React.createElement(NoLink, { key: link.name },
                    link.icon && link.icon({}),
                    isModal && React.createElement(Txt, null, link.name)));
            }
            return (React.createElement(Link, { to: url + "/" + link.path, key: link.name, activeClassName: "selected" },
                link.icon && link.icon({}),
                isModal && React.createElement(Txt, null, link.name)));
        });
    };
    var sideBar = function (isModal) {
        if (isModal === void 0) { isModal = false; }
        return (React.createElement(SideBar, { open: isModal },
            React.createElement(ToggleContainer, { open: isModal, onClick: toggleClick },
                React.createElement(ToggleIcon, null),
                isModal ? React.createElement(ToggleTxt, null, "Toggle sidebar") : null),
            React.createElement(NoLink, null,
                React.createElement(LogoBg, null,
                    React.createElement(Icon, { src: LogoSmall })),
                isModal ? React.createElement(LogoImg, { src: Logo, height: "20px" }) : null),
            mapLinks(links, isModal)));
    };
    return (React.createElement(Container, { ref: modal },
        React.createElement(ModalContainer, { open: isOpen }, sideBar(true)),
        sideBar()));
};
//# sourceMappingURL=AdminSideBar.js.map